import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
import { HostLegacy, LayoutLegacy } from "@silvertours/front-legacy-entities";
import { StageContentContainer, StageCaption } from "./Stage.styles";
import { NewsletterRegistration } from "../NewsletterRegistrationLegacy";
var NewsletterStage = function() {
    var formatImage = HostLegacy.useHost().formatImage;
    var image = {
        src: formatImage("/bm/global/files/images/XL-M_1400x470_200kb.jpg"),
        alt: "Newsletter",
        id: "newsletter-stage"
    };
    return /*#__PURE__*/ _jsx(LayoutLegacy.ImageSegment, {
        image: image,
        children: /*#__PURE__*/ _jsx(StageContentContainer, {
            children: /*#__PURE__*/ _jsx(StageCaption, {
                children: /*#__PURE__*/ _jsx(NewsletterRegistration, {
                    type: "landing"
                })
            })
        })
    });
};
export { NewsletterStage };
